<script setup>
import { computed, onMounted, ref } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import SellerManagementDialog from './overview/SellerManagementDialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const store = useStore();
const sellerManagementDialogRef = ref(null);

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agents = useMapGetter('agents/getAgents');
const officialSellers = useMapGetter('agents/getOfficialSellers');
const agentUiFlags = useMapGetter('agents/getUIFlags');
const hasCachedAgents = computed(() => agents.value.length > 0);
const hasCachedOfficialSellers = computed(
  () => officialSellers.value.length > 0
);
const hasCachedAgentConversationMetric = computed(() => {
  return agentConversationMetric.value.length > 0;
});
const isLoading = computed(() => {
  return (
    (agentUiFlags.value.isFetchingOfficialSellers &&
      !hasCachedOfficialSellers.value) ||
    (uiFlags.value.isFetchingAgentConversationMetric &&
      !hasCachedAgentConversationMetric.value)
  );
});

const fetchData = () => store.dispatch('fetchAgentConversationMetric');
const openSellerManagement = () => sellerManagementDialogRef.value?.open();

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  if (!hasCachedAgents.value) {
    store.dispatch('agents/get');
  }

  if (!hasCachedOfficialSellers.value) {
    store.dispatch('agents/getOfficialSellers');
  }

  if (!hasCachedAgentConversationMetric.value) {
    fetchData();
  }

  startRefetching();
});
</script>

<template>
  <div class="flex min-w-0 w-full flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')">
      <template #control>
        <Button
          label="Gerenciar vendedores"
          icon="i-lucide-users"
          size="sm"
          color="slate"
          variant="faded"
          type="button"
          @click="openSellerManagement"
        />
      </template>
      <AgentTable
        :agents="officialSellers"
        :agent-metrics="agentConversationMetric"
        :is-loading="isLoading"
      />
      <SellerManagementDialog
        ref="sellerManagementDialogRef"
        :sellers="officialSellers"
        :agent-metrics="agentConversationMetric"
      />
    </MetricCard>
  </div>
</template>
